import { useState } from "react";

export const MODES = [["in_person", "In person"], ["phone", "Phone"], ["video", "Video"]];
export const MODE_LABEL = Object.fromEntries(MODES);
const field = "w-full px-3 py-2.5 rounded-xl border border-[#154F49]/30 bg-white text-sm text-[#1A2E2B] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#CDA34F]";

export const blankTime = () => ({ date: "", time: "10:00", duration_min: 30, mode: "in_person", video_link: "" });

export const useTimeForm = () => {
  const [v, setV] = useState(blankTime());
  const set = (k) => (e) => setV((p) => ({ ...p, [k]: k === "duration_min" ? Number(e.target.value) : e.target.value }));
  return [v, set, () => setV(blankTime())];
};

const Lbl = ({ id, text, children }) => (
  <label htmlFor={id} className="block space-y-1"><span className="text-xs font-semibold text-[#465F57]">{text}</span>{children}</label>
);

export const TimeFields = ({ v, set, prefix, compact = false }) => (
  <div className={`grid grid-cols-2 gap-3 ${compact ? "" : "sm:grid-cols-4"}`}>
    <Lbl id={`${prefix}-date`} text="Date"><input id={`${prefix}-date`} type="date" required value={v.date} onChange={set("date")} className={field} data-testid={`${prefix}-date`} /></Lbl>
    <Lbl id={`${prefix}-time`} text="Time (Eastern)"><input id={`${prefix}-time`} type="time" required step={900} value={v.time} onChange={set("time")} className={field} data-testid={`${prefix}-time`} /></Lbl>
    <Lbl id={`${prefix}-dur`} text="Length">
      <select id={`${prefix}-dur`} value={v.duration_min} onChange={set("duration_min")} className={field} data-testid={`${prefix}-duration`}>
        {[15, 30, 45, 60, 90].map((m) => <option key={m} value={m}>{m} min</option>)}
      </select>
    </Lbl>
    <Lbl id={`${prefix}-mode`} text="Format">
      <select id={`${prefix}-mode`} value={v.mode} onChange={set("mode")} className={field} data-testid={`${prefix}-mode`}>
        {MODES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
    </Lbl>
    {v.mode === "video" && (
      <div className={`col-span-2 ${compact ? "" : "sm:col-span-4"}`}>
        <Lbl id={`${prefix}-link`} text="Meeting link (Zoom, Google Meet, Teams…)"><input id={`${prefix}-link`} type="url" required placeholder="https://" value={v.video_link} onChange={set("video_link")} className={field} data-testid={`${prefix}-video-link`} /></Lbl>
      </div>
    )}
  </div>
);

export const fieldClass = field;
